module.exports = __webpack_public_path__ + "static/media/Telephone.04447345.svg";